import { FC, forwardRef, Ref } from 'react';
import { AllieModalProps } from './Modal.types';
import { StyledModal } from './Modal.styles';

export const AllieModal: FC<AllieModalProps> = forwardRef(({ ...props }: AllieModalProps, ref) => (
  <StyledModal {...props} ref={ref as Ref<HTMLIonModalElement>} />
));
